<template>
	<div>
		<div class="bg-white wrapper">
			<header
				class="header-mini d-flex flex-wrap w-100 align-items-center"
			>
				<a href="//www.mforex.pl/">
					<img src="images/mBank-logo.svg" alt="mBank" class="logo" />
				</a>
				<a
					href="//www.mforex.pl/regulacje-bezpieczenstwo"
					class="header-mini-link ml-auto"
					target="_blank"
				>
					<img
						src="images/icons/icon-ui-icon-lock.svg"
						alt="Bezpieczeństwo"
						width="15"
						class="d-none d-sm-inline-block"
					/>Bezpieczeństwo
				</a>
			</header>
			<div class="logon-container">
				<div class="logon-background"></div>
				<div class="d-flex flex-wrap" style="align-items: center">
					<div class="logon-card">
						<app-border-top />
						<div class="logon-card-body">
							<div
								v-if="getErrorCode"
								class="text-center mb-3"
								style="color: red"
							>
								{{ errorHeader }}
							</div>
							<p v-else class="logon-card-title">
								Zaloguj się do strefy Mój FX
							</p>
							<div class="logon-card-avatar">
								<img
									srcset="
										images/avatar-1.jpg    320w,
										images/avatar-1@2x.jpg 480w,
										images/avatar-1@3x.jpg 800w
									"
									sizes="(max-width: 320px) 280px,
                       (max-width: 480px) 440px,
                       800px"
									src="images/avatar-1@3x.jpg"
									alt="Login"
								/>
							</div>
							<ul v-if="!getErrorCode">
								<li>{{ cms.listItem1 }}</li>
								<li>{{ cms.listItem2 }}</li>
								<li>{{ cms.listItem3 }}</li>
							</ul>
							<ul v-if="getErrorCode">
								<li style="color: red">
									{{ errorText }}
								</li>
							</ul>
						</div>
						<div
							v-if="
								getHost
									? getHost !== domains.mbankHost
									: checkOrigin
							"
						>
							<div class="px-4">
								<div style="margin-bottom: 12px">
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div class="input mb-0 w-100">
											<input
												v-model="login"
												:class="[
													{ filled: loginFilled },
												]"
												@input="isLoginFilled()"
												@keydown.enter="logIn()"
												type="text"
												id="Login"
												maxlength="8"
											/>
											<label for="Login"
												>Identyfikator</label
											>
										</div>
										<!-- <div class="position-relative">
										<img
											src="images/icons/icon-ui-icon-help.svg"
											class="tooltip-trigger"
											width="24"
											style="margin: -2px -5px 0 0"
											:alt="cms.tooltipText"
											@mouseover="showTooltip = true"
											@mouseout="showTooltip = false"
											@click="toggleTooltip"
										/>
										<transition name="fade">
											<div
												class="tooltip"
												v-show="showTooltip"
											>
												{{ cms.tooltipText }}
											</div>
										</transition>
									</div> -->
									</div>
									<small
										v-if="loginError"
										class="d-block text-danger"
										>{{ loginError }}</small
									>
								</div>
								<div style="margin-bottom: 24px">
									<div class="input mb-0">
										<input
											v-model="password"
											:class="[
												{ filled: passwordFilled },
											]"
											@input="
												isPasswordFilled();
												hiddenPassword =
													$event.target.value;
											"
											@keydown.enter="logIn()"
											type="password"
											id="Password"
											maxlength="15"
										/>
										<label for="Password">Hasło</label>
									</div>
									<small
										v-if="passwordError"
										class="d-block text-danger"
										>{{ passwordError }}</small
									>
									<app-message-login />
								</div>
							</div>
							<button
								type="button"
								@click.prevent.stop="logIn()"
								class="btn btn-tetriary btn-login"
							>
								Zaloguj się
							</button>
						</div>
						<div
							v-else
							class="py-4 d-flex flex-wrap items-center justify-content-center"
						>
							<div class="mb-3 w-100 text-center">
								<b>Zaloguj się za pomocą:</b>
							</div>
							<a
								:href="getRedirectUrl"
								class="mBank-login-button"
								rel="noopener noreferrer"
							>
								<img
									src="images/LoginSSO.svg"
									alt="mBank logowanie"
									style="max-width: 100px; width: 100%"
								/>
							</a>
						</div>
					</div>
					<div
						v-if="
							getHost
								? getHost !== domains.mbankHost
								: checkOrigin
						"
						class="logon-info"
					>
						<img
							src="images/icons/icon-ui-icon-help.svg"
							class="tooltip-trigger mr-1"
							width="24"
							style="margin: -2px -5px 0 0"
							:alt="cms.tooltipText"
							@mouseover="showTooltip = true"
							@mouseout="showTooltip = false"
							@click="toggleTooltip"
						/>
						{{ cms.tooltipText }}
					</div>
				</div>

				<p>
					<a
						href="//www.mforex.pl/baza-wiedzy-pytania-i-odpowiedzi"
						target="_blank"
						style="color: #525455; font-size: 14px"
						>Problem z logowaniem?</a
					>
				</p>
				<login-footer />
			</div>
		</div>
		<!-- <div v-else>
   <div class="container">
     <div class="row">
       <div class="ie-status-page">
      <h2 class="col-12 text-center mb-3" style="font-size: 30px; line-height: 40px">Przykro nam, ale tymczasowo ta strona<br/> nie jest obsługiwana przez twoją przeglądarkę.</h2>
      <h2 class="col-12 text-center mb-4" style="font-size: 18px">Proszę skorzystać z innej przeglądaki np: Google Chrome.</h2> 
      <img alt="Nie udało się załądować strony" class="d-block m-auto" src="images/statusPage/search-no-results.svg" /></div>
       </div>
     </div>
    </div>-->
	</div>
</template>

<script>
import AppMessageLogin from '@/components/AppMessagesLogin';
import AppBorderTop from '@/components/AppBorderTop';
import LoginFooter from '@/views/login/partial/FooterView';
import { mapGetters } from 'vuex';

export default {
	data() {
		//Company
		return {
			// zmiana wyświetlania logowania w zalezności od tego na jakiej domenie jest user - wartości powinny być takie jak zwraca API
			/* eslint-disable */
			domains: {
				mbankHost: MBANK_HOST,
				mforexHost: MFOREX_HOST,
				myFxDomain: MFOREX_DOMAIN,
			},
			//
			login: '',
			loginFilled: false,
			loginError: '',
			password: '',
			hiddenPassword: '',
			passwordFilled: false,
			passwordError: '',
			errors: [],
			showTooltip: false,

			/* eslint-disable */
			cms: {
				listItem1: LOGIN_LISTITEM_1,
				listItem2: LOGIN_LISTITEM_2,
				listItem3: LOGIN_LISTITEM_3,
				tooltipText: LOGIN_TOOLTIP_TXT,

				errors: {
					OtherErrorLabel: OtherError,
				},
			},
			// IE: false
			/* eslint-enable */
		};
	},
	components: {
		AppMessageLogin,
		AppBorderTop,
		LoginFooter,
	},
	computed: {
		...mapGetters([
			'getHost',
			'getRedirectUrl',
			'getErrorCodeEnum',
			'getErrorCode',
		]),
		checkOrigin() {
			return window.location.origin === this.domains.myFxDomain;
		},
		errorHeader() {
			return this.checkErrorMessage(0);
		},
		errorText() {
			return this.checkErrorMessage(1);
		},
	},
	methods: {
		toggleTooltip() {
			this.showTooltip = !this.showTooltip;
		},
		logIn() {
			if (this.validation()) {
				this.$store.dispatch('logIn', {
					Login: this.login,
					Password: this.hiddenPassword,
				});
				this.password = '';
				this.login = '';
			}
		},
		validation() {
			var isValid = true;
			this.errors = [];
			this.loginError = '';
			this.passwordError = '';

			if (!this.login) {
				this.loginError = 'Identyfikator jest wymagany!';
				isValid = false;
			}

			if (!this.password) {
				this.passwordError = 'Hasło jest wymagane!';
				isValid = false;
			}

			return isValid;
		},
		isLoginFilled() {
			if (this.login && this.login.length > 0) this.loginFilled = true;
			else this.loginFilled = false;
		},
		isPasswordFilled() {
			if (this.password && this.password.length > 0)
				this.passwordFilled = true;
			else this.passwordFilled = false;
		},
		checkErrorMessage(index) {
			return this.cms.errors.OtherErrorLabel[index];
		},
	},
	mounted() {
		//konieczne ponieważ po autocomplete przegladarki nie ogarnia ze ma uzupelnione haslo
		//(login dokladam zeby bylo raźniej hasłu)
		setTimeout(() => {
			this.isLoginFilled();
			this.isPasswordFilled();
		}, 110);
		this.$store.commit('setErrorCode', this.$route.query?.errorCode);
	},
	beforeMount() {
		//   var isIE = /*@cc_on!@*/false || !!document.documentMode;
		//   if(isIE){
		//     this.IE = true
		//   }
	},
};
</script>

<style>
#PW {
	-webkit-text-security: disc;
}

.ie-status-page {
	position: absolute;
	top: 40%;
	left: 50%;
	transform: translate(-50%, -40%);
}

.mBank-login-button {
	border: 1px solid #b7b7b7;
	border-radius: 4px;
	padding: 15px 20px;
	cursor: pointer;
}
</style>
